<template>
  <section :class="sectionClass">
    <header class="jumbotron jumbotron-fluid">
      <div v-if="showText" class="container-fluid text-center">
        <h1 class="display-3 text-white">Building Software for Tomorrow</h1>
        <p class="lead pb-4 text-white">
          No matter the scope, building software that will stand the test of
          time.
        </p>
        <p>
          <a
            href="#what-i-offer"
            class="btn btn-secondary btn-lg text-white"
            role="button"
            >Learn More</a
          >
        </p>
      </div>
      <div v-if="!showText" class="row mt-5">
        <h1 class="display-3 mt-5 text-white">{{ headerText }}</h1>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    sectionClass: {
      required: true,
      type: String,
    },
    showText: {
      required: true,
      type: Boolean,
      default: false,
    },
    headerText: {
      required: false,
      type: String,
      default: "Title",
    },
  },
};
</script>
